import VueRouter from 'vue-router'

import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import Pick from "./views/Pick.vue";
import MissingCounts from "./views/MissingCounts";

const publicPages = ['/login'];
const routes = [
  {
    path: "/",
    component: Home,
  },
  {
    path: "/login",
    component: Login
  },
  {
    path: "/missingcounts",
    component: MissingCounts,
  },
  {
    path: "/pick",
    component: Pick
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  console.log("from: " + from.path);
  console.log("to:" + to.path);
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  if (authRequired && !loggedIn) {
    return next('/login');
  }
  if(loggedIn && to.path === "/login") {
    return next("/");
  }
  next();
});

export default router;
